const popupOverlay = document.querySelector(".pop-up-overlay");
const popupContainer = document.querySelector(".pop-up-content");

function openPopup() {
  if (!popupOverlay || !popupContainer) return;
  popupOverlay.style.display = "flex";
  setTimeout(() => {
    popupContainer.style.opacity = "1";
    popupContainer.style.transform = "scale(1)";
  }, 100);
}

function closePopup() {
  if (!popupOverlay || !popupContainer) return;
  popupContainer.style.opacity = "0";
  popupContainer.style.transform = "scale(0.8)";
  setTimeout(() => {
    popupOverlay.style.display = "none";
  }, 400);
}

window.addEventListener("load", openPopup);

document.addEventListener("DOMContentLoaded", () => {
  const closePopupButton = document.getElementById("closemodal");
  if (closePopupButton) closePopupButton.addEventListener("click", closePopup);
});